import { addDays, eachDayOfInterval, format, getDay } from "date-fns";
import React from "react";
import { Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ConfirmationModal } from "../../Common/Components/ConfirmationModal";
import { createRecurringOrder } from "../../Services/CartService";
import { fetchOrderFrequency } from "../../Services/MainService";
import { AddressPicker } from "../Components/AddressPicker";
import { DatePicker } from "../../Common/Components/DatePicker";
import { getItem } from "../../Services/Storage";

const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const BookRecurring = () => {
  const deliveryTypes = useSelector((x) => x.OrderTypes);
  const orderTypeId = useSelector((x) => x.OrderTypeId);
  const coupon = useSelector((x) => x.Coupon);
  const pickupDate = useSelector((x) => x.PickupDate);
  const customer = useSelector((x) => x.Customer);
  const zone = useSelector((x) => x.Zone);
  const addresses = useSelector((x) => x.Addresses);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [frequencies, setFrequencies] = React.useState([]);
  const [frequency, setFrequency] = React.useState();
  const [day, setDay] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [pickupLoading, setPickupLoading] = React.useState(false);
  const [deliveryType, setDeliveryType] = React.useState(null);
  const [showPickup, setShowPickup] = React.useState(false);
  const [pickupRange, setPickupRange] = React.useState([]);
  const [sPickup, setSPickup] = React.useState(null);
  const [sPSlot, setSPSlot] = React.useState(null);
  const [addressModal, setAddressModal] = React.useState(null);
  const [address, setAddress] = React.useState({
    pickup: null,
    delivery: null,
  });
  const [loaded, setLoaded] = React.useState(false);
  const [tAddress, setTAddress] = React.useState(null);
  const [note, setNote] = React.useState("");
  // const [weekDaysOff, setWeekDaysOff] = React.useState(null);
  const [type, setType] = React.useState("regular");
  const [bookingType, setBookingType] = React.useState(null);

  // const consumer_referral_code = customer?.referral_reward?.consumer_referral_code;
  const referred_by = getItem("referred_by");
  // console.log("referred by", referred_by)
  
  const HandlePickupChange = (e) => {
    setSPickup(e.date);
    setSPSlot(e.slot);
    dispatch({ type: "setPickupDate", payload: e });
    setShowPickup(false);
  };

  const HandleAddressChange = (e) => {
    if (e.laundry_zone_id == zone) {
      if (addressModal === "pickup") {
        setAddress((v) => ({ ...v, pickup: e }));
      } else {
        setAddress((v) => ({ ...v, delivery: e }));
      }
      setAddressModal(null);
    } else {
      setTAddress(e);
    }
  };
  const ReplaceAddress = (e) => {
    if (addressModal === "pickup") {
      setAddress((v) => ({ pickup: e, delivery: null }));
    } else {
      setAddress((v) => ({ pickup: null, delivery: e }));
    }
    setAddressModal(null);
    setTAddress(null);

    dispatch({ type: "setZone", payload: e.laundry_zone_id });
    dispatch({ type: "setCart", payload: [] });
    dispatch({ type: "setOrderType", payload: null });
    dispatch({ type: "setBookingType", payload: null });
    dispatch({ type: "setOrderTypeId", payload: null });

    dispatch({ type: "setService", payload: null });
    dispatch({ type: "setCategory", payload: null });
  };
  // const FilterRange = useCallback(
  //   (range) => {
  //     return range.filter((date) => {
  //       const day = format(date, "EEEE").toLowerCase();
  //       const dateStringFormatted = format(date, "yyyy-MM-dd");

  //       return (
  //         !weekDaysOff?.weekdaysOff.includes(day) &&
  //         !weekDaysOff?.offDays.includes(dateStringFormatted)
  //       );
  //     });
  //   },
  //   [weekDaysOff]
  // );
  const handleBookingTypeChange = (t) => {
    if (type !== t) {
      setType(t);
      setSPickup(null);
      setSPSlot(null);
      dispatch({ type: "setPickupDate", payload: null });
    }
  };
  const handleFrequencyChange = (f) => {
    if (frequency !== f) {
      setFrequency(f);
      setSPickup(null);
      setSPSlot(null);
      dispatch({ type: "setPickupDate", payload: null });
    }
  };
  const handleDayChange = (f) => {
    if (day !== f) {
      setDay(f);
      setSPickup(null);
      setSPSlot(null);
      dispatch({ type: "setPickupDate", payload: null });
    }
  };
  const placeOrder = () => {
    if (!loading) {
      setSubmitting(true);
      const payload = {
        dates: pickupRange.map((x) => ({
          pickup_date: format(x, "yyyy-MM-dd"),
        })),
        order_pickup_time_slot_id: pickupDate?.slot?.id,
        order_delivery_time_slot_id: 0,
        laundry_delivery_type_id: deliveryType?.id,
        user_id: customer.id,
        platform: 1,
        // consumer_referral_code,
        referred_by,
        payment_method: "cash_on_delivery",
        pickup_coordinates: {
          latitude: address?.pickup?.latitude,
          longitude: address?.pickup?.longitude,
        },
        destination_coordinates: {
          latitude: address?.delivery?.latitude,
          longitude: address?.delivery?.longitude,
        },
        pickup_address: {
          area: address?.pickup?.area?.[0]?.name || "",
          area_phase: address?.pickup?.phase?.[0]?.name || "",
          addressLine1: address?.pickup?.address1 || "",
          addressLine2: address?.pickup?.address2 || "",
          address: address?.pickup?.address,
          contact_person_name: address?.pickup?.contact_person_name,
          contact_person_number: address?.pickup?.contact_person_number,
        },
        destination_address: {
          area: address?.pickup?.area?.[0]?.name || "",
          area_phase: address?.pickup?.phase?.[0]?.name || "",
          addressLine1: address?.pickup?.address1 || "",
          addressLine2: address?.pickup?.address2 || "",
          address: address?.delivery?.address,
          contact_person_name: address?.delivery?.contact_person_name,
          contact_person_number: address?.delivery?.contact_person_number,
        },
        booking_type: bookingType?.id,
        zone_id: zone,
        note,
      };
      const afterOrder = (order) => {
        setSubmitting(false);
        navigate(`/app/scheduled-orders`, {
          replace: true,
        });
        dispatch({ type: "setCart", payload: [] });
        dispatch({ type: "setOrderType", payload: null });
        dispatch({ type: "setBookingType", payload: null });
        dispatch({ type: "setOrderTypeId", payload: null });

        dispatch({ type: "setService", payload: null });
        dispatch({ type: "setCategory", payload: null });
        dispatch({ type: "setDeliveryDate", payload: null });
        dispatch({ type: "setPickupDate", payload: null });
        dispatch({ type: "setCoupon", payload: null });
        dispatch({ type: "setAddresses", payload: null });
        dispatch({ type: "setNote", payload: null });
      };
      createRecurringOrder(payload).then(
        (res) => {
          afterOrder(res);
        },
        (er) => {
          setSubmitting(false);
          if (er && er.errors && er.errors.length !== 0) {
            console.log(er);
            er.errors.forEach((x) => {
              toast.error(x.message);
            });
          }
        }
      );
    }
  };
  const fetchFrequencies = () => {
    setLoading(true);
    fetchOrderFrequency().then(
      (res) => {
        setFrequencies(res);
        setLoading(false);
      },
      (er) => {
        console.warn(er);
        toast.error("Something went wrong while fetching order frequencies.");
      }
    );
  };

  React.useEffect(() => {
    fetchFrequencies();
  }, []);
  React.useEffect(() => {
    setDeliveryType(deliveryTypes.find((x) => x.id === orderTypeId));
  }, [orderTypeId, deliveryTypes]);
  // React.useEffect(() => {
  //   if (bookingType)
  //     fetchWeekDaysOff(bookingType?.id).then(
  //       (res) => setWeekDaysOff(res),
  //       () => toast.error("Something went wrong!")
  //     );
  // }, [bookingType]);
  React.useEffect(() => {
    setBookingType(
      deliveryTypes.find((x) => x.title?.trim()?.toLowerCase() === type)
    );
  }, [type, deliveryTypes]);
  React.useEffect(() => {
    setPickupLoading(true);
    if ((day || day == 0) && frequency) {
      var sd = addDays(new Date(), 1);
      const ed = addDays(sd, frequency);
      const dates = eachDayOfInterval({ start: sd, end: ed });
      const dif = dates.filter((date) => {
        const jsDay = getDay(date);
        const remappedDay = (jsDay + 6) % 7;
        return remappedDay === day;
      });
      if (pickupDate?.date && pickupDate?.slot) {
        setSPickup(pickupDate?.date);
        setSPSlot(pickupDate?.slot);
        setPickupLoading(false);
      } else setPickupLoading(false);
      setPickupRange(dif);
    } else setPickupLoading(false);
  }, [pickupDate, frequency, day]);
  React.useEffect(() => {
    if (address.delivery || address.pickup) {
      dispatch({ type: "setAddresses", payload: address });
    }
  }, [address, dispatch]);
  React.useEffect(() => {
    if (!loaded) {
      if (addresses) {
        setAddress(addresses);
      }
      setLoaded(true);
    }
  }, [addresses, loaded]);

  return (
    <>
      <div className="container" style={{ minHeight: "80vh" }}>
        <div className="row justify-content-center py-4">
          <div className="col-xl-6 col-lg-7 col-md-10 col-12">
            <h3 className="mb-1 fw-bold" style={{ letterSpacing: "-1px" }}>
              Auto Recurring Order
            </h3>
            <hr />
            {loading ? (
              <div className="col-12 text-center">
                <Spinner variant="primary" />
              </div>
            ) : (
              <>
                {/* Booking Type */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold d-block">Booking Type</span>
                    <div className="app-dates-container rounded mt-3 py-2 py-md-0">
                      <div className="col-12 px-2">
                        <div className="form-check mb-0 d-flex align-items-center flex-wrap">
                          <input
                            className="form-check-input me-3"
                            type="radio"
                            name="booking-type"
                            id="booking-type-regular"
                            value="regular"
                            checked={type === "regular"}
                            onChange={() => handleBookingTypeChange("regular")}
                          />
                          <label
                            className="form-check-label cursor-pointer"
                            htmlFor="booking-type-regular"
                          >
                            Regular
                            <small className="m-0 text-muted d-block">
                              Delivery in 2 Days
                            </small>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Order Frequency */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold d-block">Order Frequency</span>
                    <div className="app-dates-container rounded mt-3 py-2 py-md-0">
                      {frequencies.map((x) => (
                        <div className="col-12 px-2 py-2" key={x.value}>
                          <div className="form-check mb-0 d-flex align-items-center flex-wrap">
                            <input
                              className="form-check-input me-3"
                              type="radio"
                              name="order-frequency"
                              id={`frequency-${x.value}`}
                              value={x.days}
                              checked={frequency === x.days}
                              onChange={() => handleFrequencyChange(x.days)}
                            />
                            <label
                              className="form-check-label cursor-pointer"
                              htmlFor={`frequency-${x.value}`}
                            >
                              {x.label}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* Order Frequency */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold d-block">
                      Select Pickup Day
                    </span>
                    <div className="app-dates-container rounded mt-3 py-2 py-md-0">
                      <div className="row justify-content-start justify-content-md-center column-gap-3 row-gap-3 px-4 select-category-chip-container">
                        {days.map((d, i) => (
                          <div
                            className={`select-category-chip ${
                              i == day ? "selected" : ""
                            }`}
                            onClick={() => setDay(i)}
                          >
                            {d}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Address */}
                <div className="card mb-3">
                  <div className="card-body">
                    <span className="fw-semibold mb-3 d-block">Address</span>
                    <div
                      className="row cursor-pointer"
                      onClick={() => setAddressModal("pickup")}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-circle-dot"
                          style={{ color: "#32b6e9" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Pickup Address</h6>
                        <p className="m-0">
                          {address.pickup
                            ? `${address.pickup?.address1}, ${address.pickup?.address2}, ${address.pickup?.area?.[0]?.name}, ${address.pickup?.phase?.[0]?.name}`
                            : "Select address"}
                        </p>
                        <hr style={{ borderStyle: "doted" }} />
                      </div>
                    </div>

                    <div
                      className="row cursor-pointer"
                      onClick={() => setAddressModal("delivery")}
                    >
                      <div className="col-1 text-end pe-0">
                        <i
                          className="fa-solid fa-location-dot text-primary"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </div>
                      <div className="col-11">
                        <h6 className="mb-1">Delivery Address</h6>
                        <p className="m-0">
                          {address.delivery
                            ? `${address.delivery?.address1}, ${address.delivery?.address2}, ${address.delivery?.area?.[0]?.name}, ${address.delivery?.phase?.[0]?.name}`
                            : "Select address"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Date pickers */}
                <div className="card mb-3">
                  {!pickupLoading ? (
                    <div className="card-body">
                      <span className="fw-semibold d-block">
                        Schedule Date/Time
                      </span>

                      <div className="app-dates-container mt-2">
                        <div className="col-12 col-md-5 px-2">
                          <div
                            className="d-flex align-items-center py-3 cursor-pointer"
                            onClick={() => {
                              if (frequency && (day || day == 0))
                                setShowPickup(true);
                              else
                                toast.error(
                                  "Please select frequency and day first."
                                );
                            }}
                          >
                            <i
                              className="fa-regular fa-calendar-plus me-3"
                              style={{ fontSize: "22px", color: "#666" }}
                            ></i>
                            {sPickup ? format(sPickup, "eee, do MMM") : "Date"}
                            {sPSlot && sPickup ? <br /> : "/"}
                            {sPSlot
                              ? `${sPSlot?.start_time} - ${sPSlot?.end_time}`
                              : "Time"}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="w-100 text-center py-3">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* Note */}
                <div className="card  mb-3">
                  <div className="card-body">
                    <h5 className="fw-bold mb-3">Appointment Note.</h5>
                    <textarea
                      className="form-control"
                      rows="3"
                      value={note || ""}
                      onChange={(e) => setNote(e.target.value)}
                    ></textarea>
                  </div>
                </div>
                {/* Next button */}
                <div className="card border-white shadow">
                  <div className="card-body">
                    {/* {deliveryDate && pickupDate ? ( */}
                    <button
                      className="btn btn-primary w-100 text-white fw-semibold"
                      disabled={loading || submitting}
                      onClick={() => {
                        if (!pickupDate) {
                          toast.error(
                            "Please select pickup date and time to continue."
                          );
                          return;
                        }
                        if (!address.pickup || !address.delivery) {
                          toast.error(
                            "Please select pickup & delivery addresses to continue."
                          );
                          return;
                        }
                        if (pickupDate && address.pickup && address.delivery)
                          placeOrder();
                      }}
                    >
                      {submitting ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                      ) : null}
                      <span className="fw-semibold">
                        Book Auto-Recurring Order
                      </span>
                    </button>
                    {/* ) : (
                      <button
                        className="btn btn-primary w-100 text-white fw-semibold"
                        onClick={() =>
                          toast.error(
                            "Please select pickup & delivery date to continue..."
                          )
                        }
                      >
                        Come & Collect
                      </button>
                    )} */}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* Pickup date modal*/}
      <Modal
        show={showPickup}
        backdrop="static"
        keyboard={false}
        centered
        onHide={() => setShowPickup(false)}
      >
        <Modal.Header closeButton className="py-2">
          <Modal.Title style={{ fontSize: "18px" }}>
            Choose Preferred Date / Time
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPickup ? (
            <DatePicker
              range={pickupRange}
              selected={sPickup}
              onChange={HandlePickupChange}
              orderType={bookingType?.id}
              timeSlot={sPSlot}
              type={1}
            />
          ) : null}
        </Modal.Body>
      </Modal>
      {/* Addresses modal*/}

      <AddressPicker
        show={Boolean(addressModal)}
        closeButton={true}
        onHide={() => setAddressModal(null)}
        title={` Select Your ${
          addressModal === "pickup" ? "Pickup " : "Delivery"
        } Address`}
        onSelect={HandleAddressChange}
        showEdit={false}
        showDelete={false}
      />
      <ConfirmationModal
        show={Boolean(tAddress)}
        text="The Address you selected is not in the same zone as you selected in start if you change your zone your cart will be empty. Are your sure you want to change your address?"
        onYes={() => ReplaceAddress(tAddress, true)}
        onNo={() => setTAddress(null)}
      />
    </>
  );
};
